// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"e150f866","246":"098b958f","480":"5856c2ca","557":"b1a7d632","705":"72d4f8c3"}[chunkId] + ".chunk.js";
};